// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"coupon"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 19.9996H20V2.99963L17 4.99963L14.5 2.99963L12 4.99963L9.5 2.99963L7 4.99963L4 2.99963V19.9996Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 19.9996H20V2.99963L17 4.99963L14.5 2.99963L12 4.99963L9.5 2.99963L7 4.99963L4 2.99963V19.9996Z","strokeMiterlimit":2.41327,"strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 14.9996H16M12 10.9996H16M8 10.9996H8.00391V11.0035H8V10.9996Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CouponIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'coupon',
    ref,
    icon: element,
  },
));

CouponIcon.displayName = 'CouponIcon';

export default CouponIcon;
